import first from "lodash/fp/first";
class Controller {
  constructor(Mapie, GoogleMaps) {
    "ngInject";

    this.Mapie = Mapie;
    this.googleMapsUrl = GoogleMaps.getSource();
  }

  $onInit() {
    const _that = this;

    this.onMapInit = (map) => {
      this.map = map;
    };
    if (this.boundary[0].length > 2) {
      this.boundary = this.boundary.flat();
    }
    this.center = first(this.boundary).reverse().join(",");
    this.boundary = this.boundary.map((i) => [...i.reverse()]).slice(1);
    this.polygons = this.polygons.map(this.Mapie.formatPolygon);
    if (this.points) {
      this.points = this.points.map(this.Mapie.pointArray);
    }

    this.showDetails = function (event, point, markerId) {
      _that.currentPoint = point;
      _that.map.showInfoWindow(event, "pointInfoWindow", markerId);
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/polygon/polygon.controller.js